import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  GET_CAMPAIGN_SOURCE_TYPES,
  GET_MARKETING_GROUPS,
  GET_SF_FILTERS, GET_SF_SMART_VIEWS, GET_SOURCE_TYPES,
  GET_SOURCE_TYPES_BY_ACCOUNT,
} from "./actionTypes"

import {
  getSfFiltersSuccess,
  getSfFiltersError,
  getSourceTypesSuccess,
  getSourceTypesError,
  getSfSmartViewsSuccess,
  getSfSmartViewsError,
  getCampaignSourceTypesSuccess,
  getCampaignSourceTypesError,
  getSourceTypesByAccountSuccess,
  getSourceTypesByAccountError,
  getMarketingGroupsSuccess,
  getMarketingGroupsError
} from "./actions"

import { genericGetRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { STATE_STR } from "helpers/sf_constants"
import { usStatesOptionsForSf_filters } from "common/data/us_states"

function* onGetSfFilters() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sf_filters`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    const newResponse = response.map(el => (el?.name === STATE_STR ?
      { ...el, field_values: JSON.stringify(usStatesOptionsForSf_filters) } : el))
    yield put(getSfFiltersSuccess(newResponse))
  } catch (error) {
    yield put(getSfFiltersError(error))
  }
}

function* onGetSourceTypes() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_types`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getSourceTypesSuccess(response))
  } catch (error) {
    yield put(getSourceTypesError(error))
  }
}

function* onGetSfSmartViews() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sf_smart_views`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getSfSmartViewsSuccess(response))
  } catch (error) {
    yield put(getSfSmartViewsError(error))
  }
}

function* onGetCampaignSourceTypes(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const campaign_id = action.payload?.campaign_id

    const queryParams = campaign_id ? { campaign_id } : {}

    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_types/by_campaign`,
      queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getCampaignSourceTypesSuccess(response))
  } catch (error) {
    yield put(getCampaignSourceTypesError(error))
  }
}

function* onGetSourceTypesByAccount(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const account_ids = action.payload?.account_ids
    const product_type_ids = action.payload?.product_type_ids
    
    // Convert account_ids array to query parameters
    const queryParams = {
      ...(account_ids ? { account_ids } : {}),
      ...(product_type_ids ? { product_type_ids } : {}),
    }

    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/source_types/by_account`,
      queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getSourceTypesByAccountSuccess(response))
  } catch (error) {
    yield put(getSourceTypesByAccountError(error))
  }
}

function* onGetMarketingGroups() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user

    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/marketing_groups`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getMarketingGroupsSuccess(response))
  } catch (error) {
    yield put(getMarketingGroupsError(error))
  }
}

function* sfCommonDataSaga() {
  yield takeEvery(GET_SF_FILTERS, onGetSfFilters)
  yield takeEvery(GET_SOURCE_TYPES, onGetSourceTypes)
  yield takeEvery(GET_SF_SMART_VIEWS, onGetSfSmartViews)
  yield takeEvery(GET_CAMPAIGN_SOURCE_TYPES, onGetCampaignSourceTypes)
  yield takeLatest(GET_SOURCE_TYPES_BY_ACCOUNT, onGetSourceTypesByAccount)
  yield takeEvery(GET_MARKETING_GROUPS, onGetMarketingGroups)

}

export default sfCommonDataSaga
